/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { mapTo, Observable } from 'rxjs';
import { SchoolTypeInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class SchoolTypeApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'SchoolTypes');
  }

  find(params?: Record<string, any>): Observable<SchoolTypeInterface[]> {
    const path = '';
    const httpParams = this._getHttpParams({ filter: params });
    return this.get<SchoolTypeInterface[]>(path, httpParams);
  }

  getSchoolTypes(params: HttpParams): Observable<{ count: number; results: SchoolTypeInterface[] }> {
    return this.get('search', params);
  }

  deleteById(id: number): Observable<boolean> {
    const path = `${id}`;
    return this.delete<void>(path).pipe(mapTo(true));
  }

  createSchoolType(schoolType: SchoolTypeInterface): Observable<SchoolTypeInterface> {
    const path = '';
    return this.post(path, undefined, schoolType);
  }

  updateSchoolType(params: HttpParams, schoolType: SchoolTypeInterface): Observable<SchoolTypeInterface> {
    const path = '';
    return this.put<SchoolTypeInterface>(path, params, schoolType);
  }
}
